import React, { useMemo } from 'react';
import { View } from 'react-native';
import { PageContentWidth } from 'src/constants/dimensions';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import { isWebView } from 'src/utils/platform';
import styleUtils from 'src/utils/styles';
import Column from '../../10-atoms/layout/Column';
import PageContext from './PageContext';
const Page = ({ layout, style, children, ...rest }) => {
    const [{ styles }] = useTheme(stylesGenerator);
    const pageContextValue = useMemo(() => ({
        contentMaxWidth: PageContentWidth.DEFAULT,
        ...layout,
    }), [layout]);
    return (React.createElement(PageContext.Provider, { value: pageContextValue },
        React.createElement(Column, { style: [styles.container, styleUtils.containerHeight, style], ...rest },
            React.createElement(View, { style: [styles.statusBarView] }),
            children)));
};
const stylesGenerator = createThemedStyle(({ theme, dimensions: { safeAreaInsets } }) => ({
    container: {
        backgroundColor: theme.palette.background.main,
    },
    statusBarView: {
        zIndex: 10,
        // Dev builds draw the tenancy banner at the app root, including this inset.
        height: !isWebView && !__DEV__ ? safeAreaInsets.top : 0,
        backgroundColor: theme.palette.background.main,
    },
}));
export default Page;
